import styled from "styled-components";
import Button, {ButtonStatus, ButtonStyled} from "../../ui/Button/Button";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";

const Headline = styled.h1`
  color: var(--color-primary);
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
`;

const Text = styled.p`
  font-size: 16px;
  font-weight: normal;
  text-align: center;
  margin-bottom: 20px;
`;

const ThankYouFormStyled = styled.div`
`;

const SubmissionForm = styled.div`
  padding: 20px 0;
  margin: 0 auto 20px;
`;

const ButtonItem = styled.div`
  padding: 10px 0;
  max-width: 300px;
  margin:0 auto;
`;

const Input = styled.input`
  border: 2px solid var(--color-grey);
  font-size: 16px;
  width: 100%;
  padding: 10px 20px;
`;

const AlreadyPlayedForm = ({level}) => {
  const navigate = useNavigate();

  return (
    <ThankYouFormStyled>
      <Headline>You already participated</Headline>
      <Text>
        If you want to continue playing, you can help the Christmas elves to connect the christmas tree.
      </Text>
      <ButtonItem>
        <Button onClick={() => navigate(`/game/${level}`)}>To the game</Button>
      </ButtonItem>
      <ButtonItem>
        <Button onClick={() => location.href='/quiz'}>Back to overview</Button>
      </ButtonItem>
    </ThankYouFormStyled>
  );
}

export default AlreadyPlayedForm;
